import React from 'react';
import { Box, Backdrop, keyframes } from '@mui/material';
import "../../App.css";
import BxiLogo from '../../assets/logos/bxi-logo-full.png';

// Define pulse animation
const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

// Define spin animation for the outer circle
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const PageLoader = React.memo(() => {
  return (
    <Backdrop
      sx={{
        color: '#4F46E5',
        zIndex: 9999,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(8px)',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
      open={true}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        {/* Spinning outer ring */}
        <Box
          sx={{
            position: 'absolute',
            width: '120px',
            height: '120px',
            borderRadius: '50%',
            border: '3px solid rgba(34, 97, 162, 0.1)',
            borderTop: '3px solid #2261A2',
            borderRight: '3px solid #2261A2',
            animation: `${spin} 1.5s linear infinite`,
          }}
        />
        
        {/* BXI Logo with pulse animation */}
        <Box
          component="img"
          src={BxiLogo}
          alt="BXI Logo"
          sx={{
            width: '80px',
            height: 'auto',
            animation: `${pulse} 2s ease-in-out infinite`,
            zIndex: 1,
          }}
        />
      </Box>
    </Backdrop>
  );
});

export default PageLoader;


